import { mediaSignature } from "@/graphql/Common.gql";
import { gqlClient } from "@root/apollo/apollo-options";
import axios from "axios";

export default class uploaderFile {
  constructor({ onSelectCallBack, onUploadSuccess }) {
    this._inputEle = null;
    this.file = null;
    this.filepath = null;
    this.uploadOption = {
      action: "http://localhost/upload", //上传接口
      filter: "", //文件类型过滤器
      maxsize: 50, //文件上传大小限制，单位：M
      params: null, //请求参数
      beforeUploadCallback: null,
      startCallback: null, //开始上传的回调函数
      progressCallback: null, //上传进度回调函数
      successCallback: null, //上传成功回调函数
      errorCallback: null //上传错误的回调函数
    };

    this.init(onSelectCallBack, onUploadSuccess);
  }
  init(onSelectCallBack, onUploadSuccess) {
    let uploadOption = this.uploadOption;
    this._inputEle = document.createElement("input");
    this._inputEle.type = "file";
    this._inputEle.multiple = "multiple";
    this._inputEle.accept =
      ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
    this._inputEle.onchange = async e => {
      let file = e.target.files[0];
      this.file = file;
      let tmparr = file.name.split(".");
      let fileType = tmparr[tmparr.length - 1].toLowerCase();
      if (uploadOption.filter != null && uploadOption.filter != "") {
        let filterArr = uploadOption.filter.split(",");
        let notFilter = true;
        for (let i = 0; i < filterArr.length; i++) {
          if (fileType == filterArr[i].toLowerCase()) {
            notFilter = false;
            break;
          }
        }

        if (notFilter) {
          //文件类型不符合要求
          if (
            uploadOption.errorCallback != undefined &&
            uploadOption.errorCallback != null
          ) {
            uploadOption.errorCallback("File type does not meet requirements");
          }
          return;
        }
      }
      let sizeM = file.size / 1024 / 1024;
      if (sizeM > uploadOption.maxsize) {
        if (
          uploadOption.errorCallback != undefined &&
          uploadOption.errorCallback != null
        ) {
          uploadOption.errorCallback("File size does not meet requirements");
        }
        return;
      }
      onSelectCallBack(file);
      let res = await this.upload();
      onUploadSuccess(res);
    };
  }
  click() {
    this._inputEle.click();
  }
  remove() {
    this._inputEle.value = [];
    this.file = null;
  }
  async upload() {
    let tokenData = await this.getToken();
    let formData = this.createFormData(this.file, tokenData);
    let res = this.sendXhr(formData, tokenData.host);
    return res;
  }
  // 获取上传的token
  async getToken() {
    return new Promise(async (resolve, reject) => {
      if (!gqlClient) {
        // this.onfailure("gqlClient is required");
        reject("gqlClient is required");
      }

      try {
        let {
          data: { mediaSignature: resData }
        } = await gqlClient.query({
          query: mediaSignature,
          variables: {
            tenantCode: "23r"
          }
        });

        resolve(resData);
      } catch (err) {
        this.onfailure(err);
        reject(err);
      }
    });
  }
  createFormData(file, cloudOpts) {
    const type = file.type.split("/");
    const filename = `${createUUID(32, 16)}.${type[type.length - 1]}`;
    const { dir, accessid, policy, signature, domain } = cloudOpts;

    let formData = new FormData();
    formData.append("Filename", filename);
    formData.append("key", dir + filename); //存储在oss的文件路径
    formData.append("OSSAccessKeyId", accessid); //accessKeyId
    formData.append("policy", policy); //policy
    formData.append("Signature", signature); //签名
    formData.append("file", file);
    formData.append("success_action_status", "200");
    this.filepath = `${domain}/${dir}${filename}`;
    return formData;
  }

  sendXhr(formData, host) {
    return new Promise(async (resolve, reject) => {
      // if (!this.cloudOpts) {
      //   reject("Get token first");
      // }

      // if (this.onUploading) {
      //   reject("Waiting the last process end");
      // }

      try {
        //  this.onUploading = true;

        await axios.post(host, formData);

        resolve(this.filepath);
      } catch (err) {
        reject(err);
      } finally {
        // this.onUploading = false;
      }
    });
  }
}

// createUUID
function createUUID(len, radix) {
  let chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
    ""
  );
  let uuid = [],
    i;
  radix = radix || chars.length;

  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    let r;

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}
